import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import cn from 'classnames'
import { useCopyClipboard } from '../../hooks'
import LogoPixedenMusic from '../LogoPixedenMusic'
import * as Icon from '../Icons'
import styles from './modal.module.css'
import loginStyles from '../Profile/login.module.css'

function Quote({ urlParams, kind = 'filters' }) {
  const { location } = document
  const basePath = `${location.origin}${location.pathname}`
  const url = `${basePath}${urlParams}`
  const [isCopied, setCopied] = useCopyClipboard(url, {
    successDuration: 2000,
  })

  const text = `Take a look the ${
    kind === 'filters' ? 'search' : 'special selection'
  } I made on Pixeden Music`

  return (
    <div
      className={cn(styles.wrapper, styles.shareModal)}
      style={{ '--c1': '#fedda8' }}
    >
      <div className={styles.containerOut}>
        <div className={styles.logoWrapper}>
          <LogoPixedenMusic className={styles.logoPixedenMusic} />
        </div>
        <div className={styles.contentWrapper} style={{ height: '100vh' }}>
          <div className={styles.sidebar}>
            <img
              alt="Pixden Music"
              src={require(`../../images/walkman.jpg`)}
              className={styles.shareModalImage}
            />
            <h3 className={styles.textBig}>
              Share your {kind === 'filters' ? 'search' : 'selection'} <br />
              with anyone
            </h3>
            <div className={styles.plyerGrid}></div>
          </div>
          <div className={styles.mainSide}>
            <p className={styles.textSmall}>
              You can easily copy this link to share your{' '}
              {kind === 'filters'
                ? 'search and filter music results'
                : 'custom music selection'}{' '}
              to anyone and start collaborating on your music project right now.
            </p>
            <label
              htmlFor="email"
              className={cn(loginStyles.label, styles.shareModalLabel)}
            >
              Url
              <AnimatePresence>
                {isCopied && (
                  <motion.div
                    className={loginStyles.inputError}
                    animate={{
                      opacity: 1,
                    }}
                    initial={{
                      opacity: 0,
                    }}
                    exit={{
                      opacity: 0,
                    }}
                    onAnimationComplete={() => {
                      // setTimeout(() => setErrorMessage(null), 2000)
                    }}
                  >
                    Copied to Clipboard
                  </motion.div>
                )}
              </AnimatePresence>
            </label>
            <input
              type="text"
              name="email"
              id="email"
              className={cn(loginStyles.input, styles.shareModalInput, {
                [styles.copied]: isCopied,
              })}
              autoComplete="off"
              value={url}
              readOnly
              onClick={setCopied}
            />
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                url
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialButton}
            >
              <Icon.Facebook />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                text
              )}&url=${encodeURIComponent(
                url
              )}&via=pixeden&hashtags=music,audio&related=pixeden%3APixeden`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialButton}
            >
              <Icon.Twitter />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quote
